// @flow
import React from "react";
import moment from "moment-timezone";
import Typography from "../Typography";
import StarRating from "../StarRating";
import ReadMore from "../ReadMore";

import styles from "./review.module.scss";

type T = (string, string) => string;

type ReviewItem = {
  sender: string,
  createdAt: Date | string | number,
  rating: number,
  comment: string
};

type Props = {
  review: ReviewItem,
  t: T,
  containerClassName?: string
};

const Review = ({ review, t, containerClassName }: Props) => {
  return (
    <div className={`${styles.reviewContainer} ${containerClassName}`}>
      <div className={styles.reviewHeading}>
        <Typography size="secondary" bold>
          {review.sender}
        </Typography>
        <Typography size="subtext" className={styles.date}>
          {moment(review.createdAt).format("Do MMMM YYYY")}
        </Typography>
      </div>

      <StarRating rating={review.rating} hideCount onClickStar={() => {}} />

      <ReadMore
        buttonClassName={styles.readMoreBtn}
        label={t("cta:readMore", "Read more")}
      >
        <Typography size="secondary" className={styles.comment}>
          <div>{review.comment}</div>
        </Typography>
      </ReadMore>
    </div>
  );
};

export default Review;
